import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import CoreuiVue from '@coreui/vue'
import { CIcon } from '@coreui/icons-vue'
import moment from 'moment'

import VueGtag from 'vue-gtag'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const app = createApp(App)

// app.config.compilerOptions.comments = true
app.config.globalProperties.moment = moment

app.use(createPinia())
app.use(CoreuiVue)
app.use(router)
app.use(VueGtag, {
  config: { id: 'G-62F1F57BTK' }
})

//  icon init
library.add(faSearch)
dom.watch()

app.component('CIcon', CIcon)
app.component('font-awesome-icon', FontAwesomeIcon)

app.mount('#app')
